import { DriveItemType } from '@/drive/entities/DriveItem/DriveItem.types';
import { DriveNode } from '@/drive/entities/DriveNode';

export function normalizeDriveNode(node: DriveNode): DriveNode {
  if (node.type !== DriveItemType.Folder) {
    return node;
  }

  const children = node.children ? node.children.map(normalizeDriveNode) : [];

  return { ...node, children };
}
